import React from 'react';
import Sidebar from '../components/Sidebar/Sidebar';
import styles from './CRMLayout.module.css';

const CRMLayout = ({ children, activeTab, setActiveTab }) => {
  return (
    <div className={styles.layoutContainer}>
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <main className={styles.mainContent}>
        {children}
      </main>
    </div>
  );
};

export default CRMLayout;
